import axios from "axios"
import { appConst } from "../../AppConst"
import { ICommonRequest } from "../../model/request/ICommonRequest"
import { INhapKhoDelete } from "../../model/request/category/INhapKhoDelete"
import { INhapKhoImportRequest } from "../../model/request/category/INhapKhoImportRequest"
import { IXuatKhoRequest } from "../../model/request/category/IXuatKhoRequest"
import { IXuatKhoBatchRequest } from "../../model/request/category/IXuatKhoBatchRequest"
import { INhapKho } from "../../model/respone/category/INhapKho"
import { apiClient } from "../apiClient"

export const NHAPKHO_API_RESOURCE = "uf_nhapkho"

export interface INhapKhoExportRequest extends ICommonRequest {
    uf_sanpham_ids?: number[];
    tu_ngay?: string;
    den_ngay?: string;
}

export const nhapKhoApi = {
    SelectAll: () => apiClient.get(`${NHAPKHO_API_RESOURCE}`),
    Insert: (payload: INhapKho) => apiClient.post(`${NHAPKHO_API_RESOURCE}`, payload),
    Update: (payload: INhapKho) => apiClient.put(`${NHAPKHO_API_RESOURCE}`, payload),
    Delete: (data: INhapKhoDelete) => apiClient.delete(`${NHAPKHO_API_RESOURCE}/${data.id}?ly_do_xoa=${encodeURIComponent(data.ly_do_xoa)}`),
    SelectById: (id: number) => apiClient.get(`${NHAPKHO_API_RESOURCE}/select_by_id/${id}`),
    LoadFromExcel(request: FormData) {
        return apiClient.upload(`${NHAPKHO_API_RESOURCE}/import/load-from-excel`, request)
    },
    SaveDataExcel(request: INhapKhoImportRequest) {
        return apiClient.post(`${NHAPKHO_API_RESOURCE}/import/save-data-excel`, request)
    },
    XuatKho: (payload: IXuatKhoRequest) => apiClient.post(`${NHAPKHO_API_RESOURCE}/xuat-kho`, payload),
    XuatKhoBatch: (payload: IXuatKhoBatchRequest) => apiClient.post(`${NHAPKHO_API_RESOURCE}/xuat-kho-batch`, payload),
    ExportExcel: async (request: INhapKhoExportRequest) => {
        const url = `${appConst.baseApiURL}/${NHAPKHO_API_RESOURCE}/export-excel`;
        const response = await axios.post(url, request, {
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${localStorage.access_token}`,
                language: localStorage.getItem("language") || "",
            },
        });

        const contentDisposition = response.headers["content-disposition"] as string | undefined;
        const fileNameMatch = contentDisposition?.match(/filename="?([^";]+)"?/i);

        return {
            blob: response.data as Blob,
            fileName: fileNameMatch?.[1] || "lich-su-nhap-kho.xlsx",
        };
    },
}